var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { okBtnAction: "send" },
      on: { onCloseClick: _vm.cleanModalState },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { class: { "required-flag": true } }, [
          _vm._v(_vm._s(_vm.$t("tenancy.greenOperation.sendReminderHint"))),
        ]),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.$t("hint.continue")))]),
      ]),
      _vm._v(" "),
      _c("HKLForm", { ref: "form", staticClass: "check-validation" }, [
        _c("div", { staticClass: "text-input" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.reminderComment,
                expression: "reminderComment",
              },
              { name: "autosize", rawName: "v-autosize" },
              { name: "hkldinput", rawName: "v-hkldinput" },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  required: true,
                },
                expression:
                  "{\n          type: 'string',\n          required: true\n        }",
              },
            ],
            attrs: {
              placeholder: _vm.$t(
                "tenantProjects.finalDocuments.sendReminder.placeHolder"
              ),
            },
            domProps: { value: _vm.reminderComment },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.reminderComment = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }